import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function TopPlayer() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [top, setTop] = useState("");
  const onTopChanged = useCallback((event) => setTop(event.target.value), []);

  const [allTime, setAllTime] = useState(true);
  const onAllTimeChange = useCallback(
    (event) => setAllTime(event.target.checked),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [profile, setProfile] = useState("");
  const onProfileChanged = useCallback((p) => setProfile(p), []);
  const { values: profiles } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetPlayerProfile`,
  });

  const [limitProfile, setLimitProfile] = useState("");
  const onLimitProfileChanged = useCallback((lp) => setLimitProfile(lp), []);
  const { values: limitProfiles } = useDataFormatterHook({
    addEmpty: true,
    value: "profileName",
    text: "profileName",
    path: `/Player/GetPlayerProfileLimits`,
  });

  const [currency, setCurrency] = useState("");
  const onCurrencyChanged = useCallback((c) => setCurrency(c), []);
  const { values: currencies } = useDataFormatterHook({
    addEmpty: true,
    value: "currency",
    text: "currency",
    path: `/Agent/Currency_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile"
          name="name"
          data={profiles}
          placeholder="DataFormatter"
          setSelectValue={onProfileChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile Limits"
          name="name"
          data={limitProfiles}
          placeholder="DataFormatter"
          setSelectValue={onLimitProfileChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Currency"
          name="name"
          data={currencies}
          placeholder="DataFormatter"
          setSelectValue={onCurrencyChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Top"
          type="text"
          value={top}
          size="small"
          onChange={onTopChanged}
          InputLabelProps={{ shrink: true }}
        />
        <SubGroup
          title="Settled Range"
          className="grid grid-cols-2 col-span-2 p-4"
        >
          <div className="flex">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={allTime}
                  onChange={onAllTimeChange}
                  color="primary"
                />
              }
              label="All"
            />
            <TextField
              disabled={allTime}
              className="flex-1"
              required
              variant="outlined"
              id="gameDateTime"
              label="From"
              type="date"
              value={startDate}
              size="small"
              onChange={onStartDateChange}
              InputLabelProps={{ shrink: true }}
            />
          </div>
          <TextField
            disabled={allTime}
            required
            variant="outlined"
            id="gameDateTime"
            label="To"
            type="date"
            value={endDate}
            size="small"
            onChange={onEndDateChange}
            InputLabelProps={{ shrink: true }}
          />
        </SubGroup>

        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Winners"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Losers"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Top Player Report"
        getUrl={() => "/Reports/Report_Top_Player_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          Office: office,
          Group: group,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Book: book,
          LineType: lineType,
          Profile: profile,
          ProfileLimits: limitProfile,
          Currency: currency,
          TopN: top,
          AllTime: allTime,
          StartDate: startDate,
          EndDate: endDate,
          OrderBy: orderBy,
          Distributor: distributor,
        })}
        getProcess={(data) =>
          data.map((item) => {
            const netPercent = `${Math.round(
              (item.net / (item.win - item.lose) + Number.EPSILON) * 10000
            ) / 100
              }%`;
            return { ...item, netPercent };
          })
        }
        getTotals={(data) => {
          const totalWin =
            Math.round(data.reduce((acc, item) => acc + item.win, 0) * 100) /
            100;
          const totalLose =
            Math.round(data.reduce((acc, item) => acc + item.lose, 0) * 100) /
            100;
          const totalNet =
            Math.round(data.reduce((acc, item) => acc + item.net, 0) * 100) /
            100;
          const totalNetPercent = `${Math.round(
            (totalNet / (totalWin - totalLose) + Number.EPSILON) * 10000
          ) / 100
            }%`;

          return {
            player: "",
            currency: "Totals",
            win: totalWin,
            lose: totalLose,
            net: totalNet,
            netPercent: totalNetPercent,
          };
        }}
      >
        {/* REAL COLUMNS */}
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        {/* ACCESS */}
        <TableHeaderColumn dataSort dataField="currency">
          Currency
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="win"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lose"
          dataFormat={decimalInvertedReportFormatter}
        >
          Lose
        </TableHeaderColumn>
        {/* PENDING */}
        <TableHeaderColumn
          dataSort
          dataField="net"
          dataFormat={decimalInvertedReportFormatter}
        >
          Net
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="netPercent">
          Net %
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default TopPlayer;
